import { components } from 'apiTyped/types';

export const formatFilters = (
  filters: components['schemas']['PriceFilter'][]
) =>
  filters.map((item: any) => ({
    ...item,
    vintages: item.vintages.sort((a: string, b: string) => b.localeCompare(a))
  }));
